module.exports = __webpack_public_path__ + "images/feishu/dark-logo-6722d54e9d10bb0ce418fbb53183b0e9.png";